import Utils from "../../../../../shared/utils";

export const FIRST_SECTION_ANIMATION = Utils.buildProductPageImageLink("rent/doublecheck/first-section-animation.svg");
export const POINT_ANIMATION = Utils.buildProductPageImageLink("rent/doublecheck/point-animation.svg");
export const MAIN_HEADER_ICON = Utils.buildProductPageImageLink("icons/pawn-icon.svg");
